import { numberWithCommas } from "@/utils";
import { Typography, Tooltip } from "@mui/material";

export const columns: IColumn<CountryData>[] = [
  {
    name: "Country of Origin/Export",
    key: "_id",
    align: "left",
    width: "18%",
    minWidth: "120px",
  },
  {
    name: "HTS Code(s)",
    key: "htsCount" as any,
    align: "left",
    width: "12%",
    minWidth: "80px",
    component: (data) => {
      const count = (data as any).htsCount || 0;
      return (
        <Typography variant="body2" color="text.primary" sx={{ fontSize: { xs: '9px', md: '10px', lg: '11px' } }}>
          {count} HTS Codes
        </Typography>
      );
    },
  },
  {
    name: "Goods Value",
    key: "customValue",
    align: "left",
    width: "11%",
    minWidth: "75px",
    component: ({ customValue }) => {
      const label = `$${numberWithCommas(customValue)}`;
      return (
        <Tooltip title={label} arrow>
          <Typography 
            variant="body2" 
            sx={{ fontSize: { xs: '9px', md: '10px', lg: '11px' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {label}
          </Typography>
        </Tooltip>
      );
    },
  },
  {
    name: "Customs Duty",
    key: "customDuty",
    align: "left",
    width: "11%",
    minWidth: "75px",
    component: ({ customDuty }) => {
      const label = `$${numberWithCommas(customDuty)}`;
      return (
        <Tooltip title={label} arrow>
          <Typography 
            variant="body2" 
            sx={{ fontSize: { xs: '9px', md: '10px', lg: '11px' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {label}
          </Typography>
        </Tooltip>
      );
    },
  },
  {
    name: "Effective Duty Rate",
    key: "effectiveDutyRate",
    align: "left",
    width: "13%",
    minWidth: "80px",
    component: ({ effectiveDutyRate }) => {
      const rate = effectiveDutyRate * 100;
      const color = rate < 5 ? "#2E7D32" : rate < 10 ? "#ED6C02" : "#D32F2F";
      const backgroundColor = rate < 5 ? "#E8F5E9" : rate < 10 ? "#FFF3E0" : "#FFEBEE";
      return (
        <Typography 
          variant="body2" 
          sx={{ 
            color,
            backgroundColor,
            fontWeight: 700,
            padding: { xs: "1px 3px", md: "2px 4px" },
            borderRadius: "4px",
            display: "inline-block",
            fontSize: { xs: "8px", md: "9px", lg: "10px" }
          }}
        >
          {rate.toFixed(2)}%
        </Typography>
      );
    },
  },
  {
    name: "Distinct Imports",
    key: "distinctImports",
    align: "center",
    width: "10%",
    minWidth: "70px",
  },
  {
    name: "Distinct Suppliers",
    key: "distinctSuppliers",
    align: "left",
    width: "13%",
    minWidth: "90px",
  },
  {
    name: "Avg. Shipment Value",
    key: "avgShipmentValue",
    align: "left",
    width: "12%",
    minWidth: "100px",
    component: ({ avgShipmentValue }) => {
      const label = `$${numberWithCommas(avgShipmentValue)}`;
      return (
        <Tooltip title={label} arrow>
          <Typography 
            variant="body2" 
            sx={{ fontSize: { xs: '9px', md: '10px', lg: '11px' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {label}
          </Typography>
        </Tooltip>
      );
    },
  },
];
